<template>
  <img
    class="processing-icon"
    src="../assets/img/processing.png"
    alt="Processing Icon"
  />
</template>
